import React from 'react';

import type { TDesktop } from '../models/desktop';
import type { TMobile } from '../models/mobile';

/**
 * Функция отображения хлебных крошек основной версии баннера
 * @param props пропс виджета
 */
export function bannerBreadcrumbs(props: TDesktop | TMobile) {
    const { Breadcrumbs, breadcrumbs, styles, theme } = props;

    return breadcrumbs ? (
        <div className={styles.breadcrumbs}>
            <Breadcrumbs paths={breadcrumbs} size="s" theme={theme} />
        </div>
    ) : null;
}
